import { option } from 'fp-ts';
import { constant, pipe } from 'fp-ts/function';
import { LocalizedText } from '@mews/framework';
import { ageToString, getAgeCategoryLabelTextKey } from './utils';

interface AgeCategoryLabelProps {
    categoryName: string;
    minimalAge: option.Option<number>;
    maximalAge: option.Option<number>;
}

export const AgeCategoryLabel = ({ categoryName, maximalAge, minimalAge }: AgeCategoryLabelProps) =>
    pipe(
        { minimalAge, maximalAge },
        getAgeCategoryLabelTextKey,
        option.map((key) => (
            <LocalizedText
                textKey={key}
                substitutes={{
                    categoryName,
                    maxAge: ageToString(maximalAge),
                    minAge: ageToString(minimalAge),
                }}
            />
        )),
        option.getOrElseW(constant(<>{categoryName}</>))
    );
